import backend, {AGENTCORE_ENGINE_API} from 'utils/backend/server/api_library';

const getCaseJobs = (caseRn) => {
  const url = `${AGENTCORE_ENGINE_API}/case/${caseRn}/agent_jobs`;
  return backend.get(url);
};

const updatePayload = (agentJobRn, actionPayload) => {
  const url = `${AGENTCORE_ENGINE_API}/agent_jobs/${agentJobRn}/payload`;
  const body = {
    actionPayload,
  };

  return backend.put(url, body);
};

const updateExecutionTime = (agentJobRn, executeAt) => {
  const url = `${AGENTCORE_ENGINE_API}/agent_jobs/${agentJobRn}/execution_time`;
  const body = {
    executeAt,
  };

  return backend.put(url, body);
};

const cancelJob = (agentJobRn) => {
  const url = `${AGENTCORE_ENGINE_API}/agent_jobs/${agentJobRn}/cancel`;
  return backend.post(url, {});
};

export default {
  getCaseJobs,
  updatePayload,
  updateExecutionTime,
  cancelJob,
};
